import { useQuery } from '@tanstack/react-query';
import { OpUnitType } from 'dayjs';
import Api, { withAcl } from 'hooks/Api';
import { EVENT_TABS, EVENT_TYPES } from 'utils/constants';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { dayjs } from 'utils/providers/Timezone';
import { ApiError, Event } from 'utils/types';

import { eventsTransformer } from '../transformers';
import c from '../utils/constants';

export interface Params {
  selectedDate: Date | string;
  tab: EVENT_TABS;
  guests: string[];
  dealId?: string;
  enabled?: boolean;
  eventTypes: EVENT_TYPES[];
}

export default function useGetEvents({
  selectedDate,
  tab,
  guests,
  eventTypes,
  dealId,
  enabled = true,
}: Params) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  const params = {
    startAt: JSON.stringify({
      $gte: dayjs(selectedDate)
        .startOf(tab as unknown as OpUnitType)
        .toDate(),
      $lt: dayjs(selectedDate)
        .endOf(tab as unknown as OpUnitType)
        .toDate(),
    }),
    endAt: JSON.stringify({
      $gte: dayjs(selectedDate)
        .startOf(tab as unknown as OpUnitType)
        .toDate(),
      $lt: dayjs(selectedDate)
        .endOf(tab as unknown as OpUnitType)
        .toDate(),
    }),
    guests,
    dealId,
    type: eventTypes,
  };

  return useQuery<Event[], ApiError>({
    queryKey: [c.EVENTS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/calendar/events',
            params,
            transformer: eventsTransformer.events,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/calendar/events`,
            params,
            transformer: eventsTransformer.events,
          },
        }),
      );

      return data?.data;
    },
    enabled,
  });
}
